<style lang="scss" scoped>
.tokens {
	min-height: 130px;
	&__loading {
		img {
			height: 30px;
			margin-right: 8px;
		}
	}
}
</style>

<template lang="pug">
    .tokens
        el-table(v-if="$apollo.loading || TokensFiltered.length", v-loading="$apollo.loading", ref="multipleTable", :data="TokensFiltered", @selection-change="handleSelectionChange")
            el-table-column(type="selection", width="80", align='left', v-if="!this.$route.params.school")
            el-table-column(property="access", width="110" label="Type", align='center')
                template(slot-scope="scope")
                    el-tag(size="small", :type="tagType(scope.row.access)") {{ scope.row.access | capitalise }}
            el-table-column(property="TokenAuthor.display_name", label="Author") 
            el-table-column(property="school", label="School", :show-overflow-tooltip="true")
                template(slot-scope="scope")
                    template(v-if="scope.row.TokenSchool && scope.row.TokenSchool.name")
                        router-link(:to="{ name: 'schools.show', params: {school: scope.row.TokenSchool.id } }") {{ scope.row.TokenSchool.name }} 
                    template(v-else) {{ scope.row.school}} 
            el-table-column(property="TokenCompany.name", label="Company", :show-overflow-tooltip="true") 
            el-table-column(property="access_key_display", label="Token", width='130', align='center')
                template(slot-scope="scope")
                    template(v-if="!scope.row.access_key_display") {{ scope.row.access_key}}
                    template(v-else) 
                        el-button(type="text",@click="openCopyAccessKey(scope.row.access_key)") View token 
        empty(v-else) {{this.$route.params.school ? "No tokens found" : "You don't have any tokens yet."}}
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import ShowTokenModal from "./ShowTokenModal";

export default {
	name: "TokenList",
	computed: {
		TokensFiltered: function() {
			if (!this.Tokens || !this.Tokens.results) {
				return [];
			}

			return this.Tokens.results.map(token => {
				let createdAt = moment(token.created_at);
				token.access_key_display = !(moment().diff(createdAt, "minutes") > 15);
				return token;
			});
		}
	},
	methods: {
		tagType(type) {
			switch (type) {
				case "write":
					return "danger";
				default:
					return "primary";
			}
		},
		handleSelectionChange(val) {
			this.$emit("update-selection", val);
		},
		openCopyAccessKey(val) {
			this.$vuedals.open({
				title: "Access token",
				component: ShowTokenModal,
				props: {
					token: val
				}
			});
		}
	},
	apollo: {
		Tokens: {
			query: gql`
				query Tokens($school: ID, $page: Int) {
					Tokens(school: $school, cursor: $page) {
						results {
							id
							access
							access_key
							school
							TokenAuthor {
								id
								display_name
							}
							TokenSchool {
								id
								name
							}
							TokenCompany {
								id
								name
							}
							created_at
						}
						cursor
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					school: this.$route.params.school || null,
					page: 1
				};
			}
		}
	}
};
</script>
